var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// import { ActivatedRoute } from '@angular/router';
var SocketSidekickService = /** @class */ (function () {
    function SocketSidekickService(
    // private injector: Injector
    ) {
        this.socketParamName = 'socketParam';
    }
    SocketSidekickService.prototype.checkSocketParam = function () {
        var _this = this;
        var hash = window.location.hash ? decodeURIComponent(window.location.hash) : '';
        // Reference: https://developers.arcgis.com/documentation/core-concepts/security-and-authentication/browser-based-user-logins/#using-the-arcgis-api-for-javascript
        var splits = hash.split('#');
        splits.find(function (s) {
            var reg = _this.socketParamName + '=([^&]+)';
            var matchParam = s.match(new RegExp(reg));
            if (matchParam && matchParam[1]) {
                _this.socketParam = matchParam[1];
                return true;
            }
        });
        // const socketParam = this.injector.get(ActivatedRoute) //.snapshot.paramMap.get(this.socketParamName);
        // if (socketParam) {
        // 	console.log('start sockettttttttttttttttttt');
        // } else {
        // 	console.log('noooooooooooooo')
        // }
    };
    SocketSidekickService.prototype.sendMessage = function (msg) {
        if (this.socket) {
            this.socket.send(msg);
        }
    };
    SocketSidekickService.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var socket;
            return __generator(this, function (_a) {
                socket = new WebSocket("ws://localhost:9000/");
                socket.onopen = function () { console.log("success"); };
                socket.onmessage = function (msg) { console.log(msg.data); };
                socket.onclose = function () { console.log("closed"); };
                this.socket = socket;
                return [2 /*return*/];
            });
        });
    };
    ;
    SocketSidekickService.prototype.disconnectSocket = function () {
        this.socket.close();
    };
    SocketSidekickService.prototype.onInitMap = function () {
        if (this.socketParam) {
            this.socket.send("Start");
        }
    };
    SocketSidekickService.prototype.onDestroyMap = function () {
        if (this.socketParam) {
            this.socket.send("End");
        }
    };
    SocketSidekickService.prototype.onSync = function (content, type) {
        if (this.socket) {
            this.socket.send(JSON.stringify({
                type: type,
                content: content
            }));
        }
    };
    return SocketSidekickService;
}());
export { SocketSidekickService };
